module.exports = __webpack_public_path__ + "img/box-open-full.6a765794.svg";